import React, { Component } from 'react';

import { Routes as routes } from '../navigation';
import { Header } from '../components';
import '../css/SignIn.css';

class PracticeCodeInfo extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  renderPracticeCode = () => {

    let practice = this.props.practice;

    if (!practice) {
      return null
    }

    let is_client_screen = this.props.clients_screen === true ? true : false;

    let section_height   = this.props.clients_screen === true ? 135 : '';
    let font_size        = this.props.clients_screen === true ? 13  : 14;

    let title            = this.props.clients_screen === true ? 'Connect with Clients Using Your Practice Code' : 'Connect With Clients: Your unique practice code';

    return <div className="standard-container" style={{ maxHeight: section_height }}>
      <Header title={title} icon='fas fa-link'/>
      <div className="flex-container flex-container-row" style={{ marginTop: 10, alignItems: 'center', justifyContent: 'flex-start', padding: 15, paddingTop: 5 }}>
        <div style={{ }}>
          <div className="flex-container flex-container-column" style={{ paddingRight: 10, alignItems: 'flex-start' }}>

            { !is_client_screen ? <div style={{ fontSize: font_size, color: 'grey' }}>
              <span>Clients can connect with your practice using your unique code</span>
              <span style={{ marginLeft: 8, marginRight: 8, color: '#1dc2ff' }}>{ practice.code.toUpperCase() }</span>
              <span>. This code can be customized and branded to fit your practice -- just reach out to support@teletails.com for assistance.</span>
            </div> : null }

            { is_client_screen ? <div style={{ fontSize: font_size, color: 'grey' }}>
              <span>Your code is</span>
              <span style={{ marginLeft: 8, marginRight: 8, color: '#1dc2ff' }}>{ practice.code.toUpperCase() }</span>
              <span>. This practice code is your unique identifier on TeleTails. Make sure you provide your code to clients! Want to customize the code? Email support@teletails.com.</span>
            </div> : null }

          </div>
        </div>
      </div>
    </div>
  }

  render() {
    return this.renderPracticeCode();
  }

}


export default PracticeCodeInfo
